require('fg-frontend/third/highslide/highslide-full');

var hs = window.hs;

hs.graphicsDir = '/img/highslide/';
//hs.transitions = ['expand', 'crossfade'];
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = '';
hs.align = 'center';
hs.dimmingOpacity = 0.9;
hs.restoreDuration = 175;
hs.dimmingDuration = 350;

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
hs.captionEval = 'this.a.title';
hs.marginRight = 60;
hs.marginLeft = 60;
if ( window.projectConfig.lang == 'cs' ) {
  hs.lang = {
    cssDirection: 'ltr',
    loadingText: 'Nahrávám...',
    loadingTitle: 'Klikněte pro zavření',
    focusTitle: 'Klikněte pro zobrazení v popředí',
    fullExpandTitle: 'Zvětšit na aktuální velikost (f)',
    creditsText: 'Powered by <i>Highslide JS</i>',
    creditsTitle: 'Přejít na hlavní stránku Highslide',
    previousText: 'Předchozí',
    nextText: 'Následující',
    moveText: 'Posunout',
    closeText: 'Zavřít',
    closeTitle: 'Zavřít (esc)',
    resizeTitle: 'Změnit velikost',
    playText: 'Přehrát',
    playTitle: 'Přehrát slideshow (mezerník)',
    pauseText: 'Pauza',
    pauseTitle: 'Pauznout slideshow (mezerník)',
    previousTitle: 'Předchozí (šipka vlevo)',
    nextTitle: 'Následující (šipka vpravo)',
    moveTitle: 'Posunout',
    fullExpandText: '1:1',
    number: 'Obrázek %1 z %2',
    restoreTitle: 'Klikněte pro zavření obrázku, klikněte a přetáhněte. Použijte šipky pro předchozí a následující.'
  };
}


if (hs.registerOverlay) {
    hs.registerOverlay({
        fade: 2,
        hideOnMouseOut: false,
        html: '<a href="javascript:" onclick="return hs.close(this)" class="glyphicon glyphicon-basket-delete closebutton">Zavřít</a>',
        useOnHtml: true,
        position: 'top right'
    });
}


hs.Expander.prototype.onBeforeExpand = function(sender) {

    //jen pro obrazky
    if (sender.a.className.indexOf("hs-htmlExpand") < 0) {

        // dynamicka navigace mezi fotkami

        var arrowLeft = document.createElement('div');
        var arrowRight = document.createElement('div');

        if (sender.getAdjacentAnchor(-1)) {
            arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide-previous"><span class="glyphicon glyphicon-arrow-left"></span></a>';
            arrowLeft.className = "controlbar-arrows";
        }
        if (sender.getAdjacentAnchor(1)) {
            arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide-next"><span class="glyphicon glyphicon-arrow-right"></span></a>';
            arrowRight.className = "controlbar-arrows";
        }
        if (arrowLeft.innerHTML != "") {
            sender.createOverlay({ overlayId: arrowLeft, useOnHtml: true, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' });
        }
        if (arrowRight.innerHTML != "") {
            sender.createOverlay({ overlayId: arrowRight, useOnHtml: true, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' });
        }
    }

    $('body').swipe("enable");
    $('body').swipe( {
        //Generic swipe handler for all directions
        swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
            console.log("You swiped " + direction );
            if ( direction == 'left' ) {
                return hs.next();
            } else if ( direction == 'right' ) {
                return hs.previous();
            }
        }
    });
};

hs.Expander.prototype.onBeforeClose = function(sender) {
    $('body').swipe("disable");
};

hs.addEventListener(window, 'resize', function() {
    var expanders = hs.expanders,
        expandDuration = hs.expandDuration,
        restoreDuration = hs.restoreDuration,
        i = expanders.length,
        a,
        exp;

    // make it quick
    hs.expandDuration = 0;
    hs.restoreDuration = 0;

    while (i--) {
        exp = expanders[i];
        if (exp) {
            a = exp.a;
            exp.close();
            a.onclick();
        }
    }

    // reset durations
    setTimeout(function() {
        hs.expandDuration = expandDuration;
        hs.restoreDuration = restoreDuration;
    }, expandDuration);

});

// Add this for preventing the last image from closing
var adjTemp = {};
hs.transit = function (adj, exp) {

    if ( adj == null) {
        adj = adjTemp;
    }

    if ( adj != null ) {
        var last = exp || hs.getExpander();
        exp = last;

        if ( adj == null ) {
            return false;
        }
        if (hs.upcoming) return false;
        else hs.last = last;
        hs.removeEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);
        try {
            hs.upcoming = adj;
            adj.onclick();
        } catch (e){
            hs.last = hs.upcoming = null;
        }
        adjTemp = adj;
    }

    return false;
};

hs.Expander.prototype.onDrag = function() {
    //e.preventDefault();
    return false;
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/highslide-settings.js